module.exports = __webpack_public_path__ + "static/menu-about-e4baa2645a3e3b0a7aa1ca348a3aef9b.jpg";